import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './lang/en';
import { es } from './lang/es';
var resources = {
    en: en,
    es: es
};
var i18n = createInstance({
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false // react already safe from xss
    },
    resources: resources
});
i18n.use(LanguageDetector).use(initReactI18next).init();
export var translate = function (key, options) {
    if (options) {
        return i18n.t(key, options);
    }
    return i18n.t(key);
};
export default i18n;
